import { transitionDuration } from '../../const/transitionDuration';
import { textColorMap, textFontMap, textVariantStyleMap } from './textConst';
export const useTextStyle = ({ font, variant, color: passedColor, underline, colorOverride, fontWeightOverride, textTransform, textDecoration, align, whiteSpace, overflow, textOverflow, display, wordWrap, maxWidth, minWidth, userSelect, }) => {
    const color = textColorMap[passedColor];
    const resultColor = colorOverride ?? color;
    const textVariantsStyle = textVariantStyleMap[variant];
    return {
        fontFamily: textFontMap[font],
        transitionProperty: 'color',
        transitionDuration: transitionDuration.short,
        color: resultColor,
        margin: 0,
        ...textVariantsStyle,
        fontWeight: fontWeightOverride ?? textVariantsStyle.fontWeight,
        textDecoration: underline ? 'underline' : textDecoration,
        textAlign: align,
        textTransform: textTransform ?? textVariantsStyle.textTransform,
        whiteSpace,
        overflow,
        textOverflow,
        display,
        wordWrap,
        maxWidth,
        minWidth,
        userSelect,
    };
};
